import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EditGroupsComponent } from '@components/manage/groups/edit-groups/edit-groups.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RouteDataService } from '@services/route-data/route-data.service';

@Component({
  selector: 'app-edit-group-dialog',
  template: ''
})
export class EditGroupDialogComponent implements OnInit {

  constructor(public dialog: NgbModal, private activatedRoute: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.openDialog();
  }

  openDialog(): void {
    var customerId = this.activatedRoute.parent.parent.snapshot.params.key;
    var groupId = this.activatedRoute.snapshot.params.key;

    const dialogRef = this.dialog.open(EditGroupsComponent, { centered: true, size: 'xxl', backdrop: 'static' });

    dialogRef.componentInstance.customerId = customerId;
    dialogRef.componentInstance.groupId = groupId;

    dialogRef.result.then((result) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    });
  }

}
